import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonIcon } from "@ionic/react"
import { useEffect, useState } from "react";
import { db } from "../../../data/db/db";
import { getPressureAngles } from "./formHelpers";
import { arrowDownOutline } from "ionicons/icons";
import { ArticleSpecs } from "../../../models/articleModel";
import { useTranslation } from "react-i18next";

interface TrocutParameterCardProps {
    isFormShowing: boolean,
    ident: string | undefined | null,
    pos: string | undefined,
    material: string | undefined,
    handleSubmit: () => void,
    isResShowing: boolean
}

interface PressureAngles {
    min: string,
    max: string
}

const TrocutParameterCard: React.FC<TrocutParameterCardProps> = ({ isFormShowing, ident, pos, material, handleSubmit, isResShowing }: TrocutParameterCardProps) => {
    const [articleSpec, setArticleSpec] = useState<ArticleSpecs | undefined>();
    const [pressureAngles, setPressureAngles] = useState<PressureAngles | undefined>();
    const { t } = useTranslation();

    useEffect(() => {
        const getData = async () => {
            const data = await db.articlesSpec.where({ ident: ident, pos: pos }).first();
            setArticleSpec(data);
            const angles = getPressureAngles(material!)
            setPressureAngles(angles);
        }

        getData()
    }, [ident, pos, material])

    const submit = () => {
        handleSubmit()
    }

    const paramContent = () => {
        return (
            <div>
                {(articleSpec && pressureAngles) && <>
                    <b>d<sub>1</sub>:</b> {Number(articleSpec.d1).toLocaleString()} mm <b>l<sub>2</sub>:</b> {Number(articleSpec.l2).toLocaleString()} mm<br />
                    <b>{t("calculatorForm.TrocutParameterForm.DC-Serie")}:</b> {articleSpec.serie === "dc" ? "Ja" : "Nein"}<br />
                    <b>{t("calculatorForm.TrocutParameterForm.Zähne")}:</b> {articleSpec.z}<br />
                    <b>&#946;<sub>min</sub> {t("calculatorForm.TrocutParameterForm.Material")}:</b> {pressureAngles.min.toLocaleString()}°<br />
                    <b>&#946;<sub>max</sub> {t("calculatorForm.TrocutParameterForm.Material")}:</b> {pressureAngles.max.toLocaleString()}°<br />
                </>}
            </div>
        )
    }

    if (isFormShowing) {
        return (
            <>
                <IonCard>
                    <IonCardHeader>
                        <IonCardTitle>{t("calculatorForm.Parameter")}</IonCardTitle>
                    </IonCardHeader>
                    <IonCardContent>
                        {paramContent()}
                        <div style={{ marginTop: 24 }}>{t("calculatorForm.TrocutParameterForm.Trocut Info Text")}</div>
                        <IonButton style={{ marginTop: 24 }} onClick={submit} expand="block">
                            <IonIcon slot="start" icon={arrowDownOutline} />{t("calculatorForm.TrocutParameterForm.Berechnen")}
                        </IonButton>
                    </IonCardContent>
                </IonCard>
            </>
        )
    } else {
        if (isResShowing) {
            return (
                <IonCard color="light">
                    <IonCardContent>
                        <div>
                            <b>{t("calculatorForm.Parameter")}:</b>
                            {paramContent()}
                        </div>
                    </IonCardContent>
                </IonCard>
            )
        }
        return null;
    }

}

export default TrocutParameterCard;